/**
 * (c) 2015 Ignite Sales, Inc.
 * User: aholmes
 * Date: 6/8/2016
 * Time: 9:28 AM
 */
import {addLocaleData} from 'react-intl';
import en from 'react-intl/locale-data/en';
import Immutable from 'immutable';

addLocaleData([...en]);

export default {
  get(messageDefinitions, messages = {}) {
    const messages_en = {};

    for (const k in messageDefinitions) {
      if (messageDefinitions.hasOwnProperty(k)) {
        const message = messageDefinitions[k];
        messages_en[message.id] = message.defaultMessage;
      }
    }

    const defaultMessages = Immutable.fromJS(messages_en);

    const windowMessages = Immutable.fromJS(window.messages);

    return defaultMessages.mergeDeep(windowMessages).mergeDeep(Immutable.fromJS(messages)).toJS();
  }
};



/** WEBPACK FOOTER **
 ** ./src/main/js/common/i18n/Messages.js
 **/